import './CenterTop.css';

export const CenterTop = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="center-top">
      {children}
    </div>
  )
}
